import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@knockrentals/knock-shared-web-v2';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  buttonPill: {
    borderRadius: '100px',
    backgroundColor: theme.palette.secondary[200],
    fontWeight: 400,
    '&:hover': {
      backgroundColor: theme.palette.denim[100],
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.denim[100],
      border: `1px solid ${theme.palette.denim[600]}`,
    },
  },
}));

export const ButtonPill = ({ children, endIcon, onClick }) => {
  const classes = useStyles();

  const defaultIcon = <Icon name="chevron-down-md" />;

  return (
    <Button
      className={classes.buttonPill}
      color="secondary"
      disableElevation
      endIcon={endIcon || defaultIcon}
      onClick={onClick}
      size="small"
      variant="text"
    >
      {children}
    </Button>
  );
};

ButtonPill.propTypes = {
  children: PropTypes.node,
  endIcon: PropTypes.node,
  onClick: PropTypes.func,
};
